import { Pipe, PipeTransform } from '@angular/core';
import { countryConstants } from '../../../core/routing/constants/country.constant';

@Pipe({
  name: 'translateLocation'
})
export class TranslateLocationPipe implements PipeTransform {

  transform(name: string): string {
    return countryConstants?.find(i => i?.nameInEng === name)?.CountryName || name;
  }

}



